import React from "react";

function AnalyticsMetricList({ items, emptyLabel, compact = false }) {
  if (!items?.length) {
    return <div className="analytics-metric-list analytics-metric-list--empty">{emptyLabel}</div>;
  }

  const listClasses = ["list-unstyled", "analytics-metric-list", compact ? "analytics-metric-list--compact" : null]
    .filter(Boolean)
    .join(" ");

  return (
    <ul className={listClasses}>
      {items.map((item) => {
        const itemClasses = ["analytics-metric-list__item", item.layout === "featured" ? "analytics-metric-list__item--featured" : null]
          .filter(Boolean)
          .join(" ");
        const valueClasses = [
          "analytics-metric-list__value",
          item.layout === "featured" ? "analytics-metric-list__value--featured" : null,
          item.valueClassName,
        ].filter(Boolean).join(" ");

        return (
          <li key={`${item.label}-${item.value}`} className={itemClasses}>
            {item.layout === "featured" ? (
              <>
                <span className="analytics-metric-list__label">{item.label}</span>
                <strong className={valueClasses}>{item.value}</strong>
                {item.hint && <small className="analytics-metric-list__hint analytics-metric-list__hint--featured">{item.hint}</small>}
              </>
            ) : (
              <>
                <div className="analytics-metric-list__copy">
                  <span className="analytics-metric-list__label">{item.label}</span>
                  {item.hint && <small className="analytics-metric-list__hint">{item.hint}</small>}
                </div>
                <strong className={valueClasses}>{item.value}</strong>
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
}

export default AnalyticsMetricList;
